import { useMutation, useQueryClient } from '@tanstack/react-query'
import { importFdsadminUser } from 'services/users'
import { useNotification } from 'components/Notification'
import { USERS_QUERY_KEY } from './useUsers'
import { getFullName } from '@the-platform-group/formatters/people'

/**
 * Mutation hook for importing a user from FDS Admin.
 * @returns {object} - { importUser, isImporting }
 */
function useImportUser() {
  const queryClient = useQueryClient()
  const { createNotification } = useNotification()

  const { mutate: importUser, isLoading: isImporting } = useMutation({
    mutationFn: serialNumber => {
      if (!serialNumber?.length) {
        return Promise.reject(new Error('Serial number is required'))
      }
      return importFdsadminUser(serialNumber)
    },
    onSuccess: response => {
      createNotification({
        message: `Successfully added ${getFullName(response)}`,
        variant: 'success',
      })
      queryClient.invalidateQueries({ queryKey: [USERS_QUERY_KEY] })
    },
    onError: error => {
      const message =
        error?.response?.data?.errors?.[0] || error?.message || 'Failed to add new user'
      createNotification({ message, variant: 'error' })
    },
  })

  return { importUser, isImporting }
}

export default useImportUser
